 //azure endpoint
 export const LOGIN_ENDPOINT = 'users/login';
 export const RESET_PASSWORD_ENDPOINT = 'users/resetPassword/';
 export const SIGNUP_ENDPOINT = 'users/register/';
 //otp
 export const GENERATE_OTP_ENDPOINT = 'notification/generateOTP/';
 export const VALIDATE_OTP_ENDPOINT = 'notification/validateMobile/';
 export const COUNTRY_ENDPOINT = '/referenceData/Countries';
 // profile endpoint 
 export const PROFILE_ENDPOINT = 'users/profile';
 export const ALLPORTTERMINALS_ENDPOIN = 'referenceData/terminals';
 export const  SINGLE_USER_PORT_PREFERENCE_ENDPOINT = 'notification/preference'
 export const ALLANNOUNCEMENTS_ENDPOINT = 'announcement/content';
 export const ALLANNOUNCEMENTSDETAILS_ENDPOINT = 'announcement/content';
 export const ADVERTISEMENTS_ENDPOINT ='advertisement/content/';
 export const   DOCUMENT_ENDPOINT = 'documents';
 export const NOTIFICATION_BY_USER_ENDPOINT ='notification/summary';
 export const ALLNOTIFICATIONS_ENDPOINT='notification/summary';
 export const ALL_WEATHER_ENDPOINT = 'referenceData/weather';
 //tracking
 export const CONTAINER_DETAILS_ENDPOINT = 'tracking/containerDetails';
 export const BILLOFLADING_DETAILS_ENDPOINT = 'tracking/billOfLading';
 export const ALL_TRUCK_DETAILS_ENDPOINT = 'tracking/truckDetails';
 export const VESSEL_NAME_ENDPOINT = 'tracking/vessels';
 export const VESSEL_DETAILS_ENDPOINT ='tracking/vesselDetails';
 // for faq flow
 export const ALL_FAQ_CATEGORY_ENDPOINT = 'customerSupport/faqCategories';
 export const ALL_FAQ_QUESTIONS_ENDPOINT ='customerSupport/faq';
 // terms and conditions
 export const TERMS_AND_CONDITIONS_ENDPOINT ='users/termsAndConditions';
 export const ACCEPT_TERMS_AND_CONDITIONS_ENDPOINT= 'users/tncConform';
 // for notification and TnC flag
 export const USER_PROFILE_DETAILS = 'users/userProfile';
 export const DISABLE_NOTIFICATION_FLAG ='notification/flagDisable';
 export const RAISE_QUERY_ENDPOINT ='customerSupport/raiseQuery';
 //truck appointment
 export const TRUCK_APPOINTMENT_DETAILS_ENDPOINT = 'tracking/truckAppointmentsUser';
 //subscription 
 export const SUBSCRIPTION_HISTORY_ENDPOINT = 'subscribe/history';
 export const SUBSCRIPTION_TILES_ACCESS_ENDPOINT ='subscribe/functions';
 export const SUBSCRIPTION_PLANS_ENDPOINT = 'subscribe/basePlans';
 export const SUBSCRIPTION_PAYMENT_ENDPOINT= 'subscribe/payment';
 //-------------------------------------------------------------------------------
 // work flow api End points
 export const GET_ALL_ROLES_ENDPOINT = 'users/appRoles'
 export const ADD_PROFILE_ENDPOINT = 'workflows/updateProfile';
 export const COMPLETE_PROFILE_FORM_ENDPOINT ='workflows/completeProfileForm';
 export const START_PROFILE_ENDPOINT ='workflows/updateProfile';
 export const GET_ALL_PROFILE_ENDPOINT ='workflows/profile/user/tasks';
 export const GET_ALL_PROFILE_DETAILS_ENDPOINT ='workflows/profile/user/tasks/ReviewProfile/variable';
 export const  REWORK_PROFILE =  'workflows/reworkProfile';
 export const VALIDATE_DRIVING_LICENCE='driver/validate';
// profile activity status
export const PROFILE_ACTIVITY_ENDPOINT="users/profileActivity";
// get all roles 
export const ALL_ROLES_ENDPOINT ='users/';
//--------------------------------------------------------
//preferences
export const GET_ALL_COMPANY_NAMES = 'services/companySearch';
export const SERVICE_PREFERENCES = 'services/preference';
//----------------------------
//proxy
export const PREADVISE_PROXY = 'services/proxy';
// service TFR and terminalhandlinh
export const TERMINAL_HANDLING_ENDPOINT =  'services/terminalHandling';
export const TFR_SERVICE_ENDPOINT = 'services/tfrService';
export const LOOKUP_ENDPOINT='config/lookup';

// generic services endpoints

export const  SERVICE_REQUEST_ENDPOINT='services/serviceRequest';
export const SERVICE_BIDQUOTE_ENDPOINT='services/bidQuote';
export const SERVICE_FILTERSRS_ENDPOINT= 'services/filterSRs';

// service catalog endpoints

export const uiFieldsMetaData_ENDPOINT = 'services/uiFieldsMetaData';
export const SERVICE_TYPES_ENDPOINT = 'services/serviceTypes';
export const SERVICE_REQUEST_SUMMARY_ENDPOINT = 'services/requestsSummary';
export const SERVICE_RESOLVE_QUOTE_ENDPOINT= 'services/resolveQuote';
export const SERVICE_CANCELLATION_POLICY_ENDPOINT = 'services/penalty';
export const SERVICE_ORDER_PREFERENCES_ENDPOINT = 'services/preference';

export const SERVICE_PAYMENT_ENDPOINT = 'services/payment';
export const SERVICE_REQUESTER_CONTAINER_ENDPOINT='services/requestContainers';

export const SERVICE_RESPONDENT_CONTAINER_ENDPOINT='services/respondentContainers';











 // // //azure endpoint
 // export const LOGIN_ENDPOINT = 'users/login';
 // export const GENERATE_OTP_ENDPOINT = 'users/generateOTP/';
 // export const VALIDATE_OTP_ENDPOINT = 'users/validateOTP/';
 // export const RESET_PASSWORD_ENDPOINT = 'users/resetPassword/';
 // export const SIGNUP_ENDPOINT = 'users/register/';
 // // profile endpoint 
 // export const PROFILE_ENDPOINT = 'users/profile';
 // export const ALLPORTTERMINALS_ENDPOIN = 'terminal/list';
 // export const  SINGLE_USER_PORT_PREFERENCE_ENDPOINT = 'announcement/preference'
 // export const ALLANNOUNCEMENTS_ENDPOINT = 'announcement/content';
 // export const ALLANNOUNCEMENTSDETAILS_ENDPOINT = 'announcement/';
 // export const COUNTRY_ENDPOINT = 'countries/';
 // export const ADVERTISEMENTS_ENDPOINT ='advertisement/content/';
 // export const   DOCUMENT_ENDPOINT = 'documents';
 // export const NOTIFICATION_BY_USER_ENDPOINT ='notification/summary';
 // export const ALLNOTIFICATIONS_ENDPOINT='notification/summary';
 // export const ALL_WEATHER_ENDPOINT = 'weather/list';
 // //tracking
 // export const CONTAINER_DETAILS_ENDPOINT = 'tracking/containerDetails';
 // export const BILLOFLADING_DETAILS_ENDPOINT = 'tracking/billOfLading';
 // export const ALL_TRUCK_DETAILS_ENDPOINT = 'tracking/truckDetails';
 // export const VESSEL_NAME_ENDPOINT = 'tracking/vessels';
 // export const VESSEL_DETAILS_ENDPOINT ='tracking/vesselDetails';
 // // for faq flow
 // export const ALL_FAQ_CATEGORY_ENDPOINT = 'customerSupport/faqCategories';
 // export const ALL_FAQ_QUESTIONS_ENDPOINT ='customerSupport/faq';
 // // terms and conditions
 // export const TERMS_AND_CONDITIONS_ENDPOINT ='users/user/termsAndConditions';
 // // for notification and TnC flag
 // export const USER_PROFILE_DETAILS = 'users/userProfile';
 // export const DISABLE_NOTIFICATION_FLAG ='users/disableNotification';
 // export const RAISE_QUERY_ENDPOINT ='customerSupport/raiseQuery';
 // // work flow api End points
 // export const ADD_PROFILE_ENDPOINT = 'workflows/updateProfile';
 // export const COMPLETE_PROFILE_FORM_ENDPOINT ='workflows/completeProfileForm';
 // export const START_PROFILE_ENDPOINT ='workflows/updateProfile';
 // export const LOGIN_ENDPOINT = 'v1/users/login';
 // export const GENERATE_OTP_ENDPOINT = 'v1/users/generateOTP/';
 // export const VALIDATE_OTP_ENDPOINT = 'v1/users/validateOTP/';
 // export const RESET_PASSWORD_ENDPOINT = 'v1/users/resetPassword/';
 // export const SIGNUP_ENDPOINT = 'v1/users/register/';
 // // profile endpoint 
 // export const PROFILE_ENDPOINT = 'v1/users/profile';
 // export const ALLPORTTERMINALS_ENDPOIN = 'utility/v1/portterminals/';
 // export const  SINGLE_USER_PORT_PREFERENCE_ENDPOINT = 'utility/v1/user/portpreference'
 // export const ALLANNOUNCEMENTS_ENDPOINT = 'utility/v1/announcements/';
 // export const ALLANNOUNCEMENTSDETAILS_ENDPOINT = 'utility/v1/announcement/';
 // export const COUNTRY_ENDPOINT = 'utility/v1/countries/';
 // export const ADVERTISEMENTS_ENDPOINT ='utility/v1/advertisement/contents/';
 // export const VESSEL_NAME_ENDPOINT = 'utility/v1/tracking/vessels';
 // export const VESSEL_DETAILS_ENDPOINT ='utility/v1/tracking/vesselDetails';
 // export const   DOCUMENT_ENDPOINT = 'utility/v1/documents';
 // export const ANNOUNCEMENT_BY_USER_ENDPOINT ='utility/v1/anouncement/';
 // export const ALLNOTIFICATIONS_ENDPOINT='utility/v1/notification/summary';
 // export const CONTAINER_DETAILS_ENDPOINT = 'utility/v1/tracking/containerDetails';
 // export const BILLOFLADING_DETAILS_ENDPOINT = 'utility/v1/tracking/billOfLading';
 // export const ALL_WEATHER_ENDPOINT = 'utility/v1/weather/list';
 // for FAQ 
 //export const ALL_FAQ_CATEGORY_ENDPOINT = 'v1/users/customerSupport/faqCategories';
 //export const ALL_FAQ_QUESTIONS_ENDPOINT ='v1/users/customerSupport/faqCategories';
 // // work flow api End points
 // export const ADD_PROFILE_ENDPOINT = 'wfm/workflows/updateProfile';
 // export const COMPLETE_PROFILE_FORM_ENDPOINT ='wfm/workflows/completeProfileForm';
 // export const START_PROFILE_ENDPOINT ='wfm/workflows/updateProfile';